const BrandMark = ({ size = 'md', className = '' }) => {
  const sizes = {
    sm: 'text-sm',
    md: 'text-lg',
    lg: 'text-2xl',
    xl: 'text-4xl',
    hero: 'text-5xl lg:text-6xl',
  };

  return (
    <span className={`font-heading font-bold ${sizes[size]} ${className}`}>
      <span className="text-signal">Drk</span>
      <span className="text-green">Lyn</span>
      <span
        className="drklynx-x"
        style={{
          color: '#050B14',
          WebkitTextStroke: '1.5px #00FF41',
          textShadow: '0 0 12px rgba(212,160,23,0.6), 0 0 24px rgba(212,160,23,0.3), 0 0 4px rgba(0,255,65,0.4)',
          filter: 'drop-shadow(0 0 6px rgba(212,160,23,0.5))',
        }}
      >
        X
      </span>
    </span>
  );
};

export default BrandMark;
